import { socialLinks } from '../../config/socialLinks'

type SocialLinksProps = {
  label?: string
  className?: string
}

export function SocialLinks({ label, className = '' }: SocialLinksProps) {
  const classes = ['social-links', className].filter(Boolean).join(' ')

  return <div className={classes}>
    {label ? <span>{label}</span> : null}
    <div>
      {socialLinks.map(({ name, url, ariaLabel, Icon }) => <a
        aria-label={ariaLabel}
        href={url}
        key={name}
        rel="noopener noreferrer"
        target="_blank"
      >
        <Icon size={24} strokeWidth={1.8}/>
      </a>)}
    </div>
  </div>
}
